import { ApplicationContext } from '../../../framework/framework/shared/ApplicationContext';
import classes from '../../../framework/framework/tools/classes';

import { ITaxonomyModel } from '../../../application/dataModels/ITaxonomyModel';
import * as style from './style.css';
import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import ExpandMoreIcon from '../../../assets/icons/ExpandMoreIcon';
import ExpandLessIcon from '../../../assets/icons/ExpandLessIcon';

import React = require('react');

interface IProps {

    currentSlug: string;
    appCtx: ApplicationContext;
    searchText: string;
}

interface IState {
    taxonomyModels: ITaxonomyModel[];
    isOpen: boolean;
}

export default class TaxonomyTree extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            taxonomyModels: [],
            isOpen: false
        };
    }

    componentDidMount() {
        Emitter.on(EventTypes.TaxonomyTree, (tree) => this.setState({ taxonomyModels: tree }));
    }

    render() {
        return (<div className={style.treeWrapper}>
            <div className={style.treeHeader}>
                <h3>
                    <a className={style.homeLink} href={this.props.appCtx.buildUrl('katalog')}>
                        Kategorie
                    </a>
                </h3>
                <div className={style.headerIcon}>
                    {!this.state.isOpen && <ExpandMoreIcon onClick={() => this.setState({ isOpen: true })}/>}
                    {this.state.isOpen && <ExpandLessIcon onClick={() => this.setState({ isOpen: false })}/>}
                </div>
            </div>
            {this.state.taxonomyModels.map(n => this.renderNode(n))}
        </div>);
    }

    renderNode(n: ITaxonomyModel): any {
        const uri = n.uri;
        const selectedNode = n.slug === this.props.currentSlug;
        const selectedStyle = selectedNode ? style.treeItemSelected : '';
        const itemStyle = classes(style.treeItem, this.state.isOpen ? style.visible : '');
        return <div key={n.slug} className={itemStyle}>
            <a className={selectedStyle} href={uri}>
                {n.name}
                {n.count > 0 && <span > ({n.count})</span>}
            </a>
            {this.props.currentSlug &&  n.children.map(n => this.renderNode(n))}
        </div>;
    }
}
